import { render } from "./DecideOnRisk.vue?vue&type=template&id=2fb9ad90&ts=true"
import script from "./DecideOnRisk.vue?vue&type=script&lang=ts"
export * from "./DecideOnRisk.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__